import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let CourseGallery = () => {
    const verticalImageList = [
        "img01.jpeg",
        "img02.jpeg",
        "img03.jpeg",
        "img04.jpeg",
        "img05.jpeg",
        "img06.jpeg",
        "img07.jpeg",
        "img08.jpeg",
        "img09.jpeg",
        "img10.jpeg",
        "img11.jpeg",
        "img12.jpeg",
        "img13.jpeg",
        "img14.jpeg",
        "img15.jpeg",
        "img16.jpeg",
        "img17.jpeg",
        "img18.jpeg",
        "img19.jpeg",
        "img20.jpeg",
        "img21.jpeg",
        "img22.jpeg",
        "img23.jpeg",
        "img24.jpeg",
        "img25.jpeg",
        "img26.jpeg",
        "img27.jpeg",
        "img28.jpeg",
        "img29.jpeg",
        "img30.jpeg",
        "img31.jpeg",
        "img32.jpeg",
        "img33.jpeg",
        "img34.jpeg",
        "img35.jpeg",
        "img36.jpeg",
        "img37.jpeg",
        "img38.jpeg",
        "img39.jpeg",
        "img40.jpeg",
        "img41.jpeg",
        "img42.jpeg",
        "img43.jpeg",
        "img44.jpeg",
        "img45.jpeg",
        "img46.jpeg",
        "img47.jpeg"
    ]

    return(
        <div className="content text-center">
            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-kurs/" + path)} rounded />)}
            </div>
        </div>
    )
}

export default CourseGallery;